import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const IssueTypeSettingsViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
IssueTypeSettingsViewTopBar.displayName = "IssueTypeSettingsViewTopBar"
